import { render, staticRenderFns } from "./TableStockLive.vue?vue&type=template&id=bf2b9f5a&scoped=true&"
import script from "./TableStockLive.vue?vue&type=script&lang=js&"
export * from "./TableStockLive.vue?vue&type=script&lang=js&"
import style0 from "./TableStockLive.vue?vue&type=style&index=0&id=bf2b9f5a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf2b9f5a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VBtn,VDataTable})
